import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useSendTracking } from 'hooks/useSendTracking';
import { ITruckerProfileProps } from 'interfaces/profile.interface';

const useOpenSearchKebabEvents = () => {
  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();

  const sendOpenKebabEvents = () => {
    sendAmplitude('trucker_search_driver_kebab', {
      type: 'busca-aberta',
    });

    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_search_driver_kebab',
        data: { type: 'busca-aberta' },
      },
      'open_search'
    );
  };

  const sendKebabEvents = (truckerData: ITruckerProfileProps, eventName: string, type: string, freightId?: string) => {
    const eventData = {
      type,
      source: 'home',
      isVerified: truckerData?.isVerified,
      isVip: truckerData?.trucker?.isVip,
    };

    sendAmplitude(eventName, {
      freightCode: freightId || textConstants.notAvailaible,
      truckerId: truckerData?.trucker?.id,
      ...eventData,
    });

    sendTrackingJaiminho(
      {
        nameEvent: eventName,
        data: {
          ...eventData,
          freightId: freightId ? `hashed|${freightId}` : textConstants.notAvailaible,
          truckerId: `hashed|${truckerData?.trucker.id}`,
        },
      },
      'open_search'
    );
  };

  return { sendOpenKebabEvents, sendKebabEvents };
};

export { useOpenSearchKebabEvents };
